import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/Home.vue'
import userAgreement from '@/views/userAgreement.vue'
import privacyPolicy from '@/views/privacyPolicy.vue'
import download from '@/views/download.vue'
import login from '@/views/login.vue'
import register from '@/views/register.vue'
import retriever from '@/views/retriever.vue'
import personal from '@/views/personal.vue'
import products from '@/views/products.vue';
import orderDetail from "@/views/orderDetail.vue";
import orderHistory from "@/views/orderHistory.vue";
import invite from "@/views/invite.vue"
import instructions from "@/views/instructions.vue"
import serviceTerms from "@/views/serviceTerms.vue"
import android from "@/views/android.vue"


Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
    meta: {
      title: "蝉鸣Cicadasing"
    }
  },
  {
    path: '/home',
    name: 'home',
    component: Home,
    meta: {
      title: "蝉鸣Cicadasing"
    }
  },
  {
    path: '/userAgreement',
    name: 'userAgreement',
    component: userAgreement,
    meta: {
      title: "用户协议 蝉鸣Cicadasing"
    }
  },
  {
    path: '/privacyPolicy',
    name: 'privacyPolicy',
    component: privacyPolicy,
    meta: {
      title: "隐私政策 蝉鸣Cicadasing"
    }
  },
  {
    path: '/download',
    name: 'download',
    component: download,
    meta: {
      title: "下载 蝉鸣Cicadasing"
    }
  },
  {
    path: '/login',
    name: 'login',
    component: login,
    meta: {
      title: "登录 蝉鸣Cicadasing"
    }
  },
  {
    path: '/register',
    name: 'register',
    component: register,
    meta: {
      title: "注册 蝉鸣Cicadasing"
    }
  },
  {
    path: '/retriever',
    name: 'retriever',
    component: retriever,
    meta: {
      title: "找回密码 蝉鸣Cicadasing"
    }
  },
  {
    path: '/personal',
    name: 'personal',
    component: personal,
    meta: {
      title: "个人中心 蝉鸣Cicadasing"
    },
    children: [
      {
        path: '/orderDetail',
        name: 'orderDetail',
        component: orderDetail,
        meta: {
          title: "订单明细 蝉鸣Cicadasing"
        }
      },
      {
        path: '/orderHistory',
        name: 'orderHistory',
        component: orderHistory,
        meta: {
          title: "我的订单 蝉鸣Cicadasing"
        }
      },
      {
        path: '/invite',
        name: 'invite',
        component: invite,
        meta: {
          title: "邀请其他人 蝉鸣Cicadasing"
        }
      },
    ]
  },
  {
    path: '/products',
    name: 'products',
    component: products,
    meta: {
      title: "产品列表 蝉鸣Cicadasing"
    }
  },
  {
    path: '/instructions',
    name: 'instructions',
    component: instructions,
    meta: {
      title: "安装说明 蝉鸣Cicadasing"
    }
  },
  {
    path: '/ServiceTerms',
    name: 'ServiceTerms',
    component: serviceTerms,
    meta: {
      title: "服务条款 蝉鸣Cicadasing"
    }
  },
  { 
    path: '/android',
    name: 'android',
    component: android,
    meta: {
      title: "android"
    }
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '*',
    redirect: '/'
  }
]

const router = new VueRouter({
  mode: 'hash',
  // base: process.env.BASE_URL,
  routes
})

import server from "@/public/service"
import { SUCCESS_CODE } from "@/public/state";
import getInterfaceData from "@/public/service/getInterfaceData";
import $store from "@/store"

import { Message} from "element-ui";

var storage = window.localStorage;
var sessionStorage = window.sessionStorage;
var notNeedLoginPath = ['/','/login','/register','/retriever','/products','/instructions','/download','/userAgreement','/privacyPolicy','/ServiceTerms'];
var needLoginPath = ['personal','orderDetail','orderHistory','invite'];

router.beforeEach((to, from, next) => {
  // next();
  // ...
  console.log("beforeEach", to, from,$store);


  if(['/login','/register','/retriever'].includes(to.path)){
    storage.removeItem("token");
    sessionStorage.removeItem("token");
  };
  let token = sessionStorage.getItem("token") || storage.getItem("token");

  if (!token && needLoginPath.includes(to.name)){
    Message({
      type:"info",
      message: "登录信息失效，请重新登录",
      showClose: true
    });
    $store.state.loginAfterRoute = JSON.parse(JSON.stringify(to));
    return next("/login");
  } else if(token){
    server.getUserInfo({ token }).then(data => {
      if (data.reCode === SUCCESS_CODE) {
        var result = getInterfaceData(data);
        $store.state.userInfo = result;
        next();
      } else if(needLoginPath.includes(to.name)){
        storage.removeItem("token");
        sessionStorage.removeItem("token")
        $store.state.userInfo = {};
        $store.state.loginAfterRoute = JSON.parse(JSON.stringify(to));
        Message({
          type:"info",
          message: "登录信息失效，请重新登录",
          showClose: true
        });
        next("/login");
      }else{
        storage.removeItem("token");
        sessionStorage.removeItem("token")
        $store.state.userInfo = {};
        next();
      }
    })
  }else if(to.path === '/orderDetail' && !$store.state.orderDetail){
    next("/orderHistory");
  }else{
    next()
  };

  // })
  // next();
})
export default router
